/* eslint-disable no-unused-vars */
import React from 'react'
import styled from 'styled-components'

const ERROR_MESSAGE_HEADING = 'Oops, something went wrong'
const ERROR_MESSAGE =
  'We apologise and are fixing the problem. Please try again at a later stage'

const ErrorMessageContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
const ErrorMessageHeading = styled('h1')`
  font-weight: 900;
`
const ErrorMessage = styled.p`
  font-size: 1.3rem;
  margin-top: 1rem;
`
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorMessageContainer>
          <div>
            <ErrorMessageHeading>{ERROR_MESSAGE_HEADING}</ErrorMessageHeading>
            <ErrorMessage>{ERROR_MESSAGE}</ErrorMessage>
          </div>
        </ErrorMessageContainer>
      )
    }

    return this.props.children
  }
}
export default ErrorBoundary
